import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

interface SimilarProductsProps {
  currentProductId: number;
}

interface Product {
  id: number;
  name: string;
  images: { src: string }[];
}

const SimilarProducts: React.FC<SimilarProductsProps> = ({ currentProductId }) => {
  const [similarProducts, setSimilarProducts] = useState<Product[]>([]);
  
  const API_URL = "https://huter.diy/wordpress/wp-json/wc/v3/products";
  const API_KEY = 'ck_b633c1877cf1de3bdbb01117e1fa8215b9b99e43';  // Замените новым ключом!
  const API_SECRET = 'cs_5c69080f905a13fda5aefffb41f6ac3988ab6478'; // Замените новым ключом!

  useEffect(() => {
    const fetchSimilarProducts = async () => {
      try {
        const response = await fetch(
          `${API_URL}?per_page=4&consumer_key=${API_KEY}&consumer_secret=${API_SECRET}`
        );
        const data: Product[] = await response.json();
        setSimilarProducts(data.filter((p) => p.id !== currentProductId));
      } catch (error) {
        console.error("Ошибка загрузки похожих товаров:", error);
      }
    };

    fetchSimilarProducts();
  }, [currentProductId]);

  return (
    <div className="mt-16">
      <h2 className="px-7 w-fit py-2 mb-5 text-4xl font-bold bg-yellow-400 rounded-xl">Similar products</h2>
      <div className="grid gap-8 grid-cols-[repeat(4,1fr)] max-md:grid-cols-[repeat(2,1fr)] max-sm:grid-cols-[1fr]">
        {similarProducts.map((product) => (
          <Link key={product.id} to={`/product/${product.id}`}>
            <div className="flex flex-col gap-4 max-sm:items-center">
              <img
                src={product.images[0]?.src || "/placeholder.jpg"}
                alt={product.name}
                className="object-contain rounded-3xl border-4 border-yellow-400 border-solid h-[272px] w-[280px]"
              />
              <h3 className="text-xl font-bold">{product.name}</h3>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default SimilarProducts;
